import Cookies from 'universal-cookie';
import URL from 'url';
import moment from 'moment/moment';
import app from '../configuration/app';
export var getCookiesObj = function getCookiesObj() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (req && req.universalCookies) {
    return req.universalCookies;
  }
  return new Cookies();
};
export var setAuthCookie = function setAuthCookie(value) {
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var rememberMe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var cookies = getCookiesObj(!process.browser && req);
  var rememberMeValue = rememberMe;
  if (rememberMe === null) {
    var rememberMeCookie = cookies.get('auth_token_remember_me');
    rememberMeValue = rememberMeCookie !== undefined && (rememberMeCookie === 'true' || rememberMeCookie === true);
  }
  var expiresDate = rememberMeValue ? moment().add(5, 'year').toDate() : moment().add(1, 'day').toDate();
  console.log(app);
  cookies.set(app.COOKIE_NAME, value, {
    path: '/',
    domain: URL.parse(app.APP_URL).hostname,
    secure: app.SECURE_COOKIE,
    expires: expiresDate
  });
  if (rememberMeValue) {
    cookies.set('auth_token_remember_me', true, {
      path: '/',
      domain: URL.parse(app.APP_URL).hostname,
      secure: app.SECURE_COOKIE,
      expires: expiresDate
    });
  }
};
export var getAuthCookie = function getAuthCookie() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var cookies = getCookiesObj(req);
  return cookies.get(app.COOKIE_NAME);
};
export var removeAuthCookie = function removeAuthCookie() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var cookies = getCookiesObj(!process.browser && req);
  cookies.remove(app.COOKIE_NAME, {
    path: '/',
    domain: URL.parse(process.env.NEXT_PUBLIC_APP_URL).hostname,
    secure: process.env.SECURE_COOKIE === 'true'
  });
  cookies.remove('auth_token_remember_me', {
    path: '/',
    domain: URL.parse(process.env.NEXT_PUBLIC_APP_URL).hostname,
    secure: process.env.SECURE_COOKIE === 'true'
  });
};
export var initCookie = function initCookie() {
  var resetCookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (resetCookie) {
    removeAuthCookie(req);
  }
};
export var setAfterAuthRedirectCookie = function setAfterAuthRedirectCookie(value) {
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var cookies = getCookiesObj(req);
  var expiresDate = moment().add(1, 'day').toDate();
  cookies.set('after_auth_redirection', value, {
    path: '/',
    domain: URL.parse(process.env.NEXT_PUBLIC_APP_URL).hostname,
    secure: process.env.SECURE_COOKIE === 'true',
    expires: expiresDate
  });
};
export var getAfterAuthRedirectCookie = function getAfterAuthRedirectCookie() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var cookies = getCookiesObj(req);
  return cookies.get('after_auth_redirection');
};
export var removeAfterAuthRedirectCookie = function removeAfterAuthRedirectCookie() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var cookies = getCookiesObj(req);
  cookies.remove('after_auth_redirection', {
    path: '/',
    domain: URL.parse(process.env.NEXT_PUBLIC_APP_URL).hostname,
    secure: process.env.SECURE_COOKIE === 'true'
  });
};